<template>
  <div class="tip-top" v-if="banner.length>0">
    <mt-swipe :show-indicators="true">
      <mt-swipe-item v-for="item in banner" :key="item.id">
        <img :src="item.pic" alt="" @click="handleClick(item.value,item.id)">
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        banner:[]
      }
    },
    created () {
      this.getBanner();
    },
    methods: {
      btnfn() {
        window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU2MzE1MTAwMA==#wechat_redirect'
      },
      async getBanner(){
        //获取banner
        const res = await this.axios.get(`https://api.ayerdudu.com/v1/banner/banners`)
        console.log(res)
        res.data.data.forEach((item) => {
          if(item.enable&&item.position_code===1){
            this.banner.push(item);
          }

        })
        console.log('banner数据---',this.banner)
      },
      async handleClick(link,id) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":1
          });

          // 跳转到目标链接
          if(link!==""){
            window.location.href = link;
          }

        } catch (error) {
          console.error("Error sending click request:", error);
          // 仍然跳转到目标链接
          if(link!==""){
            window.location.href = link;
          }
          // window.location.href = this.link;
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.tip-top{
  width: 100vw; /* 宽度为视口宽度 */
  height: calc(100vw * (110 / 750)); /* 高度按设计稿比例计算 */
  overflow: hidden; /* 防止内容溢出 */
  display: flex;
  box-sizing: content-box;
  background-color: #f8f8f8;
  position: sticky;
  top: 0; /* 设置吸顶的位置 */
  z-index: 10;
  //img{
  //  width: 73px;
  //  height: 73px;
  //  margin: 22px 14px 0 30px;
  //}
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .title{
    flex: 1;
    .big-title{
      display: block;
      font-size: 30px;
      color: #000;
      line-height: 75px;
      height: 68px;
      text-align: left;
    }
    .small-tip{
      text-align: left;
      display: block;
      font-size: 22px;
      color: #808080;
    }
  }
  .btn{
    width: 158px;
    height: 46px;
    border-radius: 24px;
    margin: 30px 60px 0 0;
    font-size: 22px;
    border: 2px solid #999;
    line-height: 48px;
    text-align: center;
  }
  .mint-swipe {
    height: 100%;
    color: #fff;
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
  }
  .mint-swipe-item {
    line-height: 100px;
  }
  .slide1 {
    background-color: #0089dc;
    color: #fff;
  }
  .slide2 {
    background-color: #ffd705;
    color: #000;
  }
  .slide3 {
    background-color: #ff2d4b;
    color: #fff;
  }
}
</style>